var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 27,
    viewBox: "0 0 39 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1872 5.82588C38.1872 5.82588 37.8105 3.17912 36.6504 2.01694C35.1814 0.487365 33.5391 0.479866 32.7857 0.389891C27.3917 -2.01166e-07 19.2932 0 19.2932 0H19.2782C19.2782 0 11.1797 -2.01166e-07 5.78571 0.389891C5.03237 0.479866 3.39007 0.487365 1.92104 2.01694C0.760882 3.17912 0.391741 5.82588 0.391741 5.82588C0.391741 5.82588 0 8.93752 0 12.0417V14.9508C0 18.055 0.384208 21.1666 0.384208 21.1666C0.384208 21.1666 0.760882 23.8134 1.9135 24.9756C3.38253 26.5051 5.31111 26.4527 6.16992 26.6176C9.25865 26.91 19.2857 27 19.2857 27C19.2857 27 27.3917 26.985 32.7857 26.6026C33.5391 26.5126 35.1814 26.5051 36.6504 24.9756C37.8105 23.8134 38.1872 21.1666 38.1872 21.1666C38.1872 21.1666 38.5714 18.0625 38.5714 14.9508V12.0417C38.5714 8.93752 38.1872 5.82588 38.1872 5.82588ZM15.3005 18.4824V7.69286L25.7193 13.1064L15.3005 18.4824Z",
    fill: "url(#paint0_linear_413_6)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_413_6",
    x1: -0.00000432623,
    y1: 12.4932,
    x2: 22.8396,
    y2: -5.08431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#005DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005DFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.d674cde63b33ed34cf623b3b9359a97a.svg";
export { ForwardRef as ReactComponent };